import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/staticData';

export default function Footer() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <>
      {/* 1. Slim Dark Review Strip (Fuld bredde, højde forøget ca. 35-40% til ca. 88px, baggrund #343434, 5 hvide stjerner, reduceret afstand efter asbest) */}
      <div className="w-full bg-[#343434] text-white h-[88px] min-h-[88px] flex items-center justify-center px-4 -mt-2">
        <a
          href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps?utm_source=smileybox&utm_medium=referral&utm_campaign=dansk-tagbyg-aps&utm_term=smileyboxv1"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full mx-auto flex items-center justify-center gap-3 transition-opacity hover:opacity-90 cursor-pointer text-decoration-none px-4 sm:px-6 lg:px-0"
          style={{ width: 'clamp(820px, 62vw, 1180px)', maxWidth: '100%' }}
        >
          {/* 5 hvide stjerner - ikke gule, orange eller guld */}
          <div className="flex items-center gap-1.5 text-white text-[15px]">
            <i className="fa-solid fa-star text-white" style={{ color: '#ffffff' }}></i>
            <i className="fa-solid fa-star text-white" style={{ color: '#ffffff' }}></i>
            <i className="fa-solid fa-star text-white" style={{ color: '#ffffff' }}></i>
            <i className="fa-solid fa-star text-white" style={{ color: '#ffffff' }}></i>
            <i className="fa-solid fa-star text-white" style={{ color: '#ffffff' }}></i>
          </div>
          <h4 className="font-['Saira'] font-medium text-xs sm:text-[13.5px] tracking-wide text-white/95 m-0">
            4,8 ud af 155 anmeldelser på Anmeld Håndværker
          </h4>
        </a>
      </div>

      {/* 2. Main Footer - Lys grå baggrund, 62vw kernebredde, 3 kolonner */}
      <footer className="site-footer w-full bg-[#F1F1F1] text-[#2E2E2E] py-14 lg:py-16">
        <div 
          className="w-full mx-auto px-4 sm:px-6 lg:px-0"
          style={{ width: 'clamp(820px, 62vw, 1180px)', maxWidth: '100%' }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-8 lg:gap-10 items-start">
            
            {/* Kolonne 1: Dansk Tagbyg ApS & Virksomhedsoplysninger */}
            <div className="column-1 md:justify-self-start">
              <h4 className="font-['Saira'] font-bold text-lg sm:text-xl text-[#2E2E2E] mb-4 tracking-tight">
                Dansk Tagbyg ApS
              </h4>

              <div className="flex gap-4 text-xs sm:text-sm font-['Open_Sans'] text-[#363636]">
                <div className="space-y-1.5 font-normal text-neutral-500 shrink-0">
                  <p className="mb-0">Ring:</p>
                  <p className="mb-0">Skriv:</p>
                  <p className="pt-2 mb-0">Adr:</p>
                  <p className="pt-6 mb-0">CVR:</p>
                </div>
                <div className="space-y-1.5 font-light text-[#2E2E2E]">
                  <p className="mb-0 font-normal">
                    <a href={COMPANY_INFO.phoneTel} className="hover:text-[#BE0F12] transition-colors">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p className="mb-0">
                    <a href={COMPANY_INFO.emailMailto} className="hover:text-[#BE0F12] transition-colors">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p className="pt-2 mb-0 leading-relaxed">
                    Schødtsmindevej 22, bygning 3<br />
                    8464 Galten
                  </p>
                  <p className="pt-2 mb-0">
                    {COMPANY_INFO.cvr}
                  </p>
                </div>
              </div>

              {/* Social ikon - Rund Facebook knap */}
              <div className="social-icons pt-5">
                <a
                  href="https://www.facebook.com/dansktagbyg"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Besøg Dansk Tagbyg på Facebook"
                  className="w-9 h-9 rounded-full bg-white hover:bg-neutral-200 text-[#2E2E2E] flex items-center justify-center transition-colors shadow-xs border border-neutral-300"
                >
                  <i className="fa-brands fa-facebook-f text-sm"></i>
                </a>
              </div>
            </div>

            {/* Kolonne 2: Nyt tag i dit område */}
            <div className="column-2 md:justify-self-start">
              <h4 className="font-['Saira'] font-bold text-lg sm:text-xl text-[#2E2E2E] mb-4 tracking-tight">
                Nyt tag i dit område
              </h4>
              <ul className="space-y-1.5 text-xs sm:text-sm text-[#2E2E2E] font-['Open_Sans']">
                {[
                  { name: 'Aarhus', path: '/p/nyt-tag/erfaren-tagdaekker-i-aarhus' },
                  { name: 'Randers', path: '/p/nyt-tag/nyt-tag-i-randers' },
                  { name: 'Horsens', path: '/p/nyt-tag/horsens' },
                  { name: 'Skanderborg', path: '/p/nyt-tag/skanderborg' },
                  { name: 'Djursland', path: '/p/nyt-tag/djursland' },
                  { name: 'Odder', path: '/p/nyt-tag/odder' },
                  { name: 'Hinnerup', path: '/p/nyt-tag/nyt-tag-i-hinnerup' },
                  { name: 'Højbjerg', path: '/p/nyt-tag/nyt-tag-i-hoejbjerg' },
                  { name: 'Risskov', path: '/p/nyt-tag/risskov' },
                  { name: 'Hammel', path: '/p/nyt-tag/nyt-tag-i-hammel' }
                ].map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="hover:text-[#BE0F12] transition-colors inline-block"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Kolonne 3: Vi løser opgaver i hele DK + Danmarkskort */}
            <div className="column-3 flex flex-col items-center text-center md:justify-self-center">
              <h4 className="font-['Saira'] font-bold text-lg sm:text-xl text-[#2E2E2E] mb-4 tracking-tight">
                Vi løser opgaver i hele DK
              </h4>
              <div className="pt-2 flex justify-center w-full">
                <img
                  src="/_assets/denmark-map.svg"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/denmark-map.svg';
                  }}
                  alt="Danmarkskort mørk silhuet"
                  loading="lazy"
                  className="w-[175px] h-auto object-contain mx-auto block"
                  style={{ width: '175px', maxWidth: '185px' }}
                />
              </div>
            </div>

            {/* Kolonne 4: Vi er medlem af + 3 medlemslogoer */}
            <div className="column-4 md:justify-self-end">
              <h4 className="font-['Saira'] font-bold text-lg sm:text-xl text-[#2E2E2E] mb-4 tracking-tight">
                Vi er medlem af
              </h4>
              <div className="flex flex-col gap-4 items-start pt-1">
                {/* 1. Swisspearl */}
                <div className="w-full flex items-center">
                  <img
                    src="/_assets/swisspearl-logo.png"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/swisspearl-logo.png';
                    }}
                    alt="Swisspearl logo"
                    loading="lazy"
                    className="h-9 sm:h-11 w-auto max-w-[200px] object-contain block"
                  />
                </div>

                {/* 2. Byg Garanti */}
                <div className="w-full flex items-center">
                  <img
                    src="/_assets/imgi-12-thumb.png"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-12-thumb.png';
                    }}
                    alt="Byg Garanti logo"
                    loading="lazy"
                    className="h-12 sm:h-14 w-auto max-w-[210px] object-contain block"
                  />
                </div>

                {/* 3. DI / Byggeri */}
                <div className="w-full flex items-center">
                  <img
                    src="/_assets/imgi-11-thumb.png"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-11-thumb.png';
                    }}
                    alt="DI Byggeri logo"
                    loading="lazy"
                    className="h-11 sm:h-13 w-auto max-w-[210px] object-contain block"
                  />
                </div>
              </div>
            </div>

          </div>

          {/* Sub-footer / Legal / Iubenda links */}
          <div className="mt-12 pt-8 border-t border-[#D9D9D9] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs sm:text-sm text-[#555] font-['Open_Sans']">
            <p className="m-0">
              © {new Date().getFullYear()} Dansk Tagbyg ApS · CVR: {COMPANY_INFO.cvr}
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <a
                href="https://www.iubenda.com/privacy-policy/30757085"
                className="iubenda-white iubenda-noiframe iubenda-embed"
                title="Privatlivspolitik "
              >
                Privatlivspolitik
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/30757085/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed"
                title="Cookiepolitik "
              >
                Cookiepolitik
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
